const ar = {
  pleaseEnterUsername: "يرجى إدخال اسم المستخدم",
  cannotFriendYourself: "لا يمكنك إرسال طلب صداقة إلى نفسك.",
  friendRequestSent: "تم إرسال طلب الصداقة!",
  failedToSendRequest: "فشل في إرسال الطلب",
  linkCopied: "تم نسخ الرابط إلى الحافظة!",
  backToInvites: "العودة إلى الدعوات",
  sendFriendRequestByUsername: "إرسال طلب صداقة باسم المستخدم",
  enterUsername: "أدخل اسم المستخدم",
  send: "إرسال",
  yourInviteQrCode: "رمز QR الخاص بدعوتك",
  inviteLink: "رابط الدعوة",
  scanQrOrUseLink: "امسح رمز QR هذا أو استخدم هذا الرابط لإرسال طلب صداقة",
  copyInviteLink: "نسخ رابط الدعوة",
  goToItem: "الانتقال إلى العنصر",
  verificationEmailSent: "تم إرسال بريد التحقق الإلكتروني! تحقق من صندوق الوارد.",
  verificationEmailFailed: "فشل إرسال بريد التحقق الإلكتروني. يرجى المحاولة مرة أخرى.",
  verifyYourEmail: "تحقق من بريدك الإلكتروني",
  verifyEmailInstructions: "يرجى التحقق من عنوان بريدك الإلكتروني للوصول إلى حسابك. تحقق من صندوق الوارد للحصول على رابط التحقق.",
  sending: "جارٍ الإرسال...",
  resendVerificationEmail: "إعادة إرسال بريد التحقق الإلكتروني",
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  home: "الرئيسية",
  calendar: "التقويم",
  friends: "الأصدقاء",
  profile: "الملف الشخصي",
  logout: "تسجيل الخروج",
  loading: "جارٍ التحميل...",
  language: "اللغة",
  calendarSelectPlaceSuggestion: "يرجى اختيار مكان من الاقتراحات حتى يتم إرفاق الإحداثيات.",
  calendarSelectDateAndTime: "يرجى اختيار التاريخ والوقت.",
  calendarPositiveDuration: "يرجى إدخال مدة موجبة.",
  calendarFutureDateRequired: "يجب أن يكون تاريخ ووقت الحدث في المستقبل.",
  calendarCreateEventFailed: "فشل إنشاء الحدث. يرجى المحاولة مرة أخرى.",
  cancel: "إلغاء",
  createNewEvent: "إنشاء حدث جديد",
  week: "أسبوع",
  month: "شهر",
  eventTitle: "العنوان",
  date: "التاريخ",
  time: "الوقت",
  duration: "المدة",
  endsAt: "ينتهي في",
  place: "المكان",
  searchForPlace: "ابحث عن مكان",
  placeSearchTip: "نصيحة: ابدأ بالكتابة ثم اختر نتيجة لإرفاق الإحداثيات.",
  description: "الوصف",
  createEvent: "إنشاء الحدث",
  today: "اليوم",
  previousMonth: "الشهر السابق",
  nextMonth: "الشهر التالي",
  previous: "السابق",
  next: "التالي",
  mondayShort: "الإثنين",
  tuesdayShort: "الثلاثاء",
  wednesdayShort: "الأربعاء",
  thursdayShort: "الخميس",
  fridayShort: "الجمعة",
  saturdayShort: "السبت",
  sundayShort: "الأحد",
  more: "المزيد",
  mustRespondWillBeforeReposting: "يجب أن تختار \"سأحضر\" قبل إعادة النشر",
  event: "حدث",
  backToCalendar: "العودة إلى التقويم",
  addToGoogleCalendar: "إضافة إلى تقويم Google",
  when: "متى",
  where: "أين",
  openLocationInGoogleMaps: "فتح الموقع في خرائط Google",
  hosts: "المضيفون",
  yourResponse: "ردك",
  currentResponse: "الرد الحالي",
  response_will: "سأحضر",
  response_might: "قد أحضر",
  response_wont: "لن أحضر",
  willRunIntoYou: "سأمر عليك",
  mightDropBy: "قد أمر عليك",
  wontCome: "لن آتي",
  repostToMyFriends: "إعادة النشر لأصدقائي",
  responses: "الردود",
  willAttend: "سأحضر",
  reposted: "تمت إعادة النشر",
  mightAttend: "قد أحضر",
  cancelEvent: "إلغاء الحدث",
  cancellationEmailNoticeBefore: "الأشخاص الذين أكدوا حضورهم",
  cancellationEmailNoticeAfter: "سيتم إخطارهم عبر البريد الإلكتروني بإلغاء الحدث.",
  optionalCancellationMessage: "رسالة اختيارية للحضور (بحد أقصى 1000 حرف)",
  confirmCancelEvent: "تأكيد إلغاء الحدث",
  clear: "مسح",
  confirmCancellation: "تأكيد الإلغاء",
  confirmCancellationMessage: "هل أنت متأكد من أنك تريد إلغاء هذا الحدث؟ سيتم إخطار الحضور المؤكدين وإزالة الحدث.",
  eventCancelledNotified: "تم إلغاء الحدث. تم إخطار",
  attendees: "الحضور",
  failedToCancelEvent: "فشل إلغاء الحدث",
  back: "رجوع",
  cancelled: "ملغى",
  ok: "موافق",
  forgotPassword: "نسيت كلمة المرور",
  email: "البريد الإلكتروني",
  passwordResetLinkSent: "إذا كان الحساب موجودًا، فقد تم إرسال رابط إعادة تعيين كلمة المرور.",
  passwordResetRequestFailed: "فشل طلب إعادة تعيين كلمة المرور.",
  sendResetLink: "إرسال رابط إعادة التعيين",
  addFriend: "إضافة صديق",
  incomingRequests: "الطلبات الواردة",
  accept: "قبول",
  deny: "رفض",
  myFriends: "أصدقائي",
  noFriendsYet: "لا يوجد أصدقاء بعد. ابدأ بإضافة بعض الأصدقاء!",
  seeProfile: "عرض الملف الشخصي",
  noEventsToRespondTo: "لا توجد أحداث للرد عليها",
  allCaughtUp: "لقد اطلعت على كل شيء. تحقق لاحقًا من أحداث أصدقائك الجديدة.",
  events: "الأحداث",
  unknown: "غير معروف",
  noDescriptionProvided: "لم يتم تقديم وصف.",
  will: "سأحضر",
  maybe: "ربما",
  wont: "لن أحضر",
  userNotFound: "المستخدم غير موجود",
  friendRequestSentSuccessfully: "تم إرسال طلب الصداقة بنجاح!",
  friendInvitation: "دعوة صداقة",
  sendFriendRequest: "إرسال طلب صداقة",
  loginToSendFriendRequest: "يرجى تسجيل الدخول لإرسال طلب صداقة",
  chooseLanguage: "اختر اللغة",
  invalidCredentials: "بيانات اعتماد غير صحيحة. يرجى المحاولة مرة أخرى.",
  username: "اسم المستخدم",
  password: "كلمة المرور",
  forgotPasswordQuestion: "هل نسيت كلمة المرور؟",
  dontHaveAccount: "ليس لديك حساب؟",
  registerHere: "أنشئ حسابًا هنا",
  invalidProfilePhotoType: "نوع الملف غير صالح. يرجى تحميل صورة JPEG أو PNG أو GIF أو WebP.",
  invalidFileExtension: "امتداد الملف غير صالح",
  allowedExtensions: "المسموح",
  fileTooLarge: "الملف كبير جدًا",
  maximumFileSize: "الحد الأقصى",
  profilePhotoRemoved: "تمت إزالة صورة الملف الشخصي.",
  failedToRemoveProfilePhoto: "فشل إزالة صورة الملف الشخصي",
  profileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح!",
  failedToUpdateProfile: "فشل تحديث الملف الشخصي",
  privateEmailExplanation: "أنت فقط من يمكنه رؤية بريدك الإلكتروني لتجنب الرسائل غير المرغوب فيها خارج المنصة",
  yourEmailIsPrivate: "بريدك الإلكتروني خاص.",
  profilePhoto: "صورة الملف الشخصي",
  removePhoto: "إزالة الصورة",
  firstName: "الاسم الأول",
  lastName: "اسم العائلة",
  tellPeopleAboutYourself: "أخبر الآخرين عن نفسك",
  whereToContactMe: "كيفية التواصل معي",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "حفظ",
  notSet: "غير محدد",
  editProfile: "تعديل الملف الشخصي",
  imageToCrop: "الصورة المراد قصها",
  zoom: "تكبير",
  usePhoto: "استخدام الصورة",
  name: "الاسم",
  whereToContact: "كيفية التواصل",
  removeFriendship: "إزالة الصداقة",
  confirmRemoveFriend: "تأكيد إزالة الصديق",
  confirmRemoveFriendBefore: "هل أنت متأكد أنك تريد إزالة",
  confirmRemoveFriendAfter: "من قائمة أصدقائك؟",
  friendRemoved: "تمت إزالة الصديق.",
  failedToRemoveFriend: "فشل إزالة الصديق.",
  confirmRemove: "تأكيد الإزالة",
  error: "خطأ",
  removed: "تمت الإزالة",
  passwordsDoNotMatch: "كلمات المرور غير متطابقة",
  registrationFailed: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
  confirmPassword: "تأكيد كلمة المرور",
  alreadyHaveAccount: "لديك حساب بالفعل؟",
  loginHere: "سجل الدخول هنا",
  passwordResetSuccessfully: "تمت إعادة تعيين كلمة المرور بنجاح.",
  failedToResetPassword: "فشل إعادة تعيين كلمة المرور.",
  resetPassword: "إعادة تعيين كلمة المرور",
  newPassword: "كلمة المرور الجديدة",
  confirmNewPassword: "تأكيد كلمة المرور الجديدة",
  setNewPassword: "تعيين كلمة المرور الجديدة",
  emailVerifiedSuccessfully: "تم التحقق من البريد الإلكتروني بنجاح!",
  emailVerificationFailed: "فشل التحقق. قد يكون الرابط غير صالح أو منتهي الصلاحية.",
  verifying: "جارٍ التحقق...",
  verified: "تم التحقق!",
  redirectingToHome: "جارٍ تحويلك إلى الصفحة الرئيسية...",
  verificationFailed: "فشل التحقق",
  goToHome: "الذهاب إلى الصفحة الرئيسية",
  about: "حول",
  aboutConceptTitle: "المفهوم",
  aboutCreatorIntroduction: "مرحبًا، أنا Crypt0، متسلق صخور ومنشئ Run Into Me.",
  aboutCreatorStory: "أنشأت هذا الموقع لأنني اجتماعي وأتحدث دائمًا مع المتسلقين الآخرين، مما جعلني أحتفظ بأرقام كثيرة وأقضي وقتًا طويلًا في تنظيم جلسات التسلق.",
  aboutPlanningProblem: "سئمت من التخطيط ومراسلة كل صديق على حدة، وأردت إبلاغ الجميع بموعد ومكان التسلق دون دعوة رسمية.",
  aboutDeveloperSolution: "ثم تذكرت أنني مطور ويمكنني إنشاء الحل بنفسي.",
  aboutWelcome: "مرحبًا بك في Run Into Me، موقع يتيح لأصدقائك معرفة الأنشطة التي يمكنهم الانضمام إليها دون ضغط.",
  aboutCallToAction: "عندما تخطط لنشاط يمكنك القيام به منفردًا لكنه أمتع مع الآخرين، انشره هنا ليراه أصدقاؤك!",
  aboutTutorialTitle: "دليل الاستخدام",
  aboutCalendarCreateEvent: "شاشة التقويم هي أيضًا المكان الذي تنشئ فيه حدثًا جديدًا.",
  aboutEventColorsIntroduction: "تشير ألوان الأحداث إلى حالة مشاركتك:",
  aboutColorGold: "ذهبي",
  aboutColorGoldDescription: "أنت تستضيف هذا الحدث.",
  aboutColorGreen: "أخضر",
  aboutColorGreenDescription: "أنت ستحضر هذا الحدث.",
  aboutColorOrange: "برتقالي",
  aboutColorOrangeDescription: "أجبت «ربما».",
  aboutColorBlue: "أزرق",
  aboutColorBlueDescription: "لم تجب بعد.",
  aboutColorGray: "رمادي",
  aboutColorGrayDescription: "رفضت الدعوة.",
  aboutCalendarEventDetails: "انقر على حدث لمزيد من المعلومات وللرد عليه.",
  aboutFriendPageTitle: "صفحة الأصدقاء",
  aboutFriendPageDescription: "لإضافة صديق، أدخل اسم المستخدم أو أرسل له رابط الدعوة / رمز QR.",
  aboutHomePageTitle: "الصفحة الرئيسية",
  aboutHomePageDescription: "تصفح أحداث أصدقائك القادمة وأخبرهم إن كنت ستحضر.",
  aboutRepostScreenTitle: "شاشة إعادة النشر",
  aboutGoogleCalendarDescription: "استخدم هذا الزر لإضافة الحدث إلى تقويم Google حتى لا يفوتك.",
  aboutRepostDescription: "بعد تأكيد حضور حدث صديق، يمكنك إعادة نشره لأصدقائك.",
};

export default ar;